module.exports = __webpack_public_path__ + "img/jcb.ee7c4fd5.png";